import { render, staticRenderFns } from "./FinanceModuleContent.vue?vue&type=template&id=37f4d763&scoped=true&"
import script from "./FinanceModuleContent.vue?vue&type=script&lang=js&"
export * from "./FinanceModuleContent.vue?vue&type=script&lang=js&"
import style0 from "./FinanceModuleContent.vue?vue&type=style&index=0&id=37f4d763&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f4d763",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VChip,VDataTable,VExpandTransition,VIcon,VProgressLinear,VTooltip})
